import React, {useEffect, useState} from 'react';
import fonts from '../../../fonts/THSarabunNew.ttf';
import fonts_bold from '../../../fonts/THSarabunNew Bold.ttf';
import {Page, Text, View, Document, StyleSheet, Image, PDFDownloadLink} from '@react-pdf/renderer';
import {PDFViewer} from '@react-pdf/renderer';
import {Font} from '@react-pdf/renderer'
import img from '../../../images/logo.png'
import Axios from 'axios';
import Constants from '../../../config/constants';
import objDefault from '../../../models/admissionPdfModel'
import moment from "moment";
import {staff} from "../../../config/staff"

const eyes = [
    {key: 4, text: 'Spontaneous (4)', value: 4},
    {key: 3, text: 'To sound (3)', value: 3},
    {key: 2, text: 'To pressure (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT) ', value: 1}
]
const arrival = [
    {key: 1, text: 'Walk in', value: 1},
    {key: 2, text: 'EMS ออกรับ', value: 2},
    {key: 3, text: 'Refer จาก รพ.กระนวน', value: 3},
    {key: 4, text: 'Refer จาก รพ.น้ำพอง', value: 4},
    {key: 5, text: 'Refer จาก รพ.เขาสวนกวาง', value: 5},
    {key: 6, text: 'Refer จาก รพ.อุบลรัตน์', value: 6},
    {key: 7, text: 'Refer จาก รพ.ขอนแก่น', value: 7},
    {key: 8, text: 'Refer จาก อื่นๆ ....', value: 8}
]
const verbal = [
    {key: 5, text: 'Orientated (5)', value: 5},
    {key: 4, text: 'Confused (4)', value: 4},
    {key: 3, text: 'Words (3)', value: 3},
    {key: 2, text: 'Sounds (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: '1'}
]
const best = [
    {key: 6, text: 'Obey commands (6)', value: 6},
    {key: 5, text: 'Localizing (5)', value: 5},
    {key: 4, text: 'Normal flexion (4)', value: 4},
    {key: 3, text: 'Abnormal flexion (3)', value: 3},
    {key: 2, text: 'Extension (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: 1}
]
Font.register({
    family: 'th',
    fonts: [
        {
            src: fonts
        },
        {
            src: fonts_bold,
            fontWeight: 'bold'
        },

    ]
})
const styles = StyleSheet.create({
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontFamily: 'th'
    },

    tableRow: {
        margin: "auto",
        flexDirection: "row",
        fontFamily: 'th'

    },
    table1: {
        display: "table",
        width: "auto",
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontFamily: 'th'
    },

    tableRow1: {

        flexDirection: "row",
        fontFamily: 'th'

    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,

        marginTop: 0
    },
    tableCell: {
        margin: 0,
        marginTop: 0,
        paddingLeft: 5,
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
    },

    tableCol3: {
        width: "50%",

        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableCol3_sub: {
        width: "100%",

        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableCol3_head: {
        width: "35%",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        marginLeft: 10
    },
    tableCol3_remark: {
        width: "65%",
        borderLeftWidth: 1,
        borderTopWidth: 0,
        textAlign: 'left',
        marginLeft: 2,
        borderStyle: 'dashed',
        borderRadius: 1,
    },
    tableCell3: {
        margin: 0,
        marginTop: 0,
        paddingLeft: 5,
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left'
    },

    tableCell2: {
        margin: 0,
        marginTop: 0,
        paddingLeft: 20,
        fontSize: 12,
    },
    tableCellData: {
        margin: 0,
        marginTop: 2,
        paddingLeft: 5,
        fontSize: 15,
        textAlign: 'center'
    },

    table2: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },

    tableRow2: {
        margin: "auto",
        flexDirection: "row",
    },
    tableCol2: {
        width: "33.33%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },

    body: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingHorizontal: 0,
        fontFamily: 'th',

    },
    textHead: {
        marginTop: 0,
        marginLeft: 15,
        marginRight: 20,
        fontSize: 13,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th',
        fontweight: 'bold'
    },
    textContrainer: {
        marginTop: 0,
        marginLeft: 18,
        marginRight: 20,
        fontSize: 12,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubContrainer: {
        marginTop: 0,
        marginLeft: 50,
        marginRight: 20,
        fontSize: 11,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubSecondary: {
        marginTop: 0,
        marginLeft: 60,
        marginRight: 20,
        fontSize: 11,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },

});


// Create Document Component
const Pdf = () => {

    const [input, setInput] = useState({
        ...objDefault
    });


    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id')
        getAdmissionById(id)


    }, [input]);


    const getAdmissionById = async (id) => {
        try {
            // console.log()
            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission?id=' + id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
            response = response.data.data[0]

            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                weight: response.weight,
                height: response.height,
                ward: response.ward,
                staff_name: response.staff_id ? staff.find(item => item.key == response.staff_id).text : '',
                resident_name: response.resident_name,
                division: response.division,
                record_name: response.record_name,
                recode_code: response.recode_code,
                record_datetime: response.record_datetime,
                gender: response.gender == 'M' ? 'ชาย' : 'หญิง',
                id: response.id,
                admission_date: response.admission_date,
                chief_complaint: response.chief_complaint,
                primary_a: response.primary_a,
                primary_b: response.primary_b,
                breathing_managements: response.breathing_managements,
                hr: response.hr,
                pr: response.pr,
                bp: response.bp,
                bp_d: response.bp_d,
                bp_s: response.bp_s,
                bt: response.bt,
                sat: response.sat,
                primary_c: response.primary_c,
                heart_sound: response.heart_sound,
                active_bleeding: response.active_bleeding,
                active_bleeding_remark: response.active_bleeding_remark,
                managements: response.managements,
                inv_eFAST: response.inv_eFAST,
                inv_ekg: response.inv_ekg,
                gcs_e: response.gcs_e ? eyes.find(item => item.key === response.gcs_e).text : '',
                gcs_v: response.gcs_v ? verbal.find(item => item.key === response.gcs_v).text : '',
                gcs_m: response.gcs_m ? best.find(item => item.key === response.gcs_m).text : '',
                pupil_response: response.pupil_response,
                primary_e: response.primary_e,
                spine_alignment: response.spine_alignment,
                pr2: response.pr2,
                ng_og_tube: response.ng_og_tube,
                inv_p_cxr: response.inv_p_cxr,
                abg: response.abg,
                alcohol_history: response.alcohol_history == 'y' ? 'Yes' : 'No',
                medication: response.medication,
                past_illness_pregnancy: response.past_illness_pregnancy,
                events: response.events,
                last_meal: response.last_meal,
                head_neck: response.head_neck,
                heart_lungs: response.heart_lungs,
                abdomen_pelvis: response.abdomen_pelvis,
                extremities: response.extremities,
                per_rectal_exam: response.per_rectal_exam,
                neurologic: response.neurologic,
                remark_secondary_survey: response.remark_secondary_survey,
                investigations: response.investigations,
                primary_diagnosis: response.primary_diagnosis,
                other_problems: response.other_problems,
                plan_of_managements: response.plan_of_managements,
                admission_id: response.admission_id,
                hn: response.hn,
                admission_number: response.admission_number,
                fractures_deformities: response.fractures_deformities,
                fractures_deformities_remark: response.fractures_deformities_remark,
                restriction_cspine_motion: response.restriction_cspine_motion,
                airway_managements: response.airway_managements,
                rr: response.rr,
                urethral_cath: response.urethral_cath,
                allergy: response.allergy,
                head_neck_remark: response.head_neck_remark,
                heart_lungs_remark: response.heart_lungs_remark,
                abdomen_pelvis_remark: response.abdomen_pelvis_remark,
                extremities_remark: response.extremities_remark,
                per_rectal_exam_remark: response.per_rectal_exam_remark,
                neurologic_remark: response.neurologic_remark,
                arrival_station : response.arrival_station !== null ? response.arrival_station:'',
                arrival_status :  response.arrival_status? arrival.find(item => item.key === response.arrival_status).text : '',
                timestamp: response.timestamp,
                age: response.age,
                an: response.an
            }))

        } catch (e) {
            console.log(e);
        }
    }


    return (

        <PDFViewer style={{width: '100%', height: '100vh',}}>


            <Document>
                <Page style={styles.body}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>

                                <Image style={{width: '55', marginLeft: '45', marginTop: '5'}}

                                       src={img}
                                />

                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>Admission note{"\n"}</Text>
                                <Text style={styles.tableCellData}> Deparment of Surgery{"\n"}</Text>
                                <Text style={{fontSize: '10', textAlign: 'center'}}>Faculty of Medicine , Khon Kaen
                                    University</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'bold'
                                }}>&nbsp;&nbsp;ผู้บาดเจ็บ {input.name} {input.surname}{"\n"}</Text>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'bold'
                                }}>&nbsp;&nbsp;HN {input.hn}&nbsp;&nbsp;&nbsp;&nbsp;AN{input.an}{"\n"}</Text>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'bold'
                                }}>&nbsp;&nbsp;เพศ {input.gender} &nbsp;&nbsp;&nbsp;&nbsp;อายุ
                                    : {input.age}{"\n"}</Text>
                                <Text style={{fontSize: 12, fontWeight: 'bold'}}>&nbsp;&nbsp;Admission Date
                                    :&nbsp;{moment(input.admission_date).format("DD-MM-YYYY")}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={{fontSize: 12, fontWeight: 'bold', marginLeft: 5}}>
                                    Ward : {input.ward}{"\n"}
                                    Staff : {input.staff_name}{"\n"}
                                    Resident : {input.resident_name}{"\n"}
                                    Division : {input.division}
                                </Text>
                            </View>
                        </View>
                    </View>
                    <Text style={styles.textHead}>
                        Chief complaint : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.chief_complaint}</Text>
                    </Text>
                    <Text style={styles.textHead}>
                        Arrival status : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.arrival_status+input.arrival_station}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>
                        Primary Survey with Simultaneous Resuscitation
                    </Text>
                    <Text style={styles.textContrainer}>
                        Airway Assessment [A] : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.primary_a}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Airway managements [A] : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.airway_managements}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Restriction of C-spine motio : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.restriction_cspine_motion}</Text>
                    </Text>
                    <Text style={styles.textContrainer}>
                        Breathing Assessment [B] : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.primary_b}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Breathing managements : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.breathing_managements}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        HR :<Text style={{
                        fontSize: 12,
                        fontWeight: 'normal',
                        marginLeft: 30
                    }}> {input.hr}/min&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        RR :<Text style={{
                        fontSize: 12,
                        fontWeight: 'normal',
                        paddingRight: 30
                    }}> {input.rr}/min&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        BP : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal',
                        paddingRight: 30
                    }}> {input.bp_s}/{input.bp_d} mm.Hg.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        BT : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal',
                        paddingRight: 30
                    }}> {input.bt} c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Sat : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal',
                        paddingRight: 30
                    }}> {input.sat} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                    </Text>

                    <Text style={styles.textContrainer}>
                        Circulation [C] Abdomen : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.primary_c}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Active bleeding : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.active_bleeding}
                        {
                            input.active_bleeding_remark ? ' ; '+input.active_bleeding_remark :''
                        }

                    </Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Fractures/deformities : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.fractures_deformities}
                        {
                            input.fractures_deformities_remark ? ' ; '+input.fractures_deformities_remark :''
                        }

                    </Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Circulation managements : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.managements}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        eFAST : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.inv_eFAST}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        EKG : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.inv_ekg}</Text>
                    </Text>

                    <Text style={styles.textContrainer}>
                        Eye opening (E) : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.gcs_e}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Verbal response (V) : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.gcs_v}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Motor respones (M) : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.gcs_m}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                        Pupil response : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.pupil_response}&nbsp;&nbsp;</Text>
                    </Text>

                    <Text style={styles.textContrainer}>
                        Per-rectal examination : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.pr2}</Text>{"\n"}
                    </Text>
                    <Text style={styles.textContrainer}>
                        <Text style={{
                            fontSize: 12,
                            fontWeight: 'normal'
                        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{input.primary_e}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            marginTop: 2,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>
                        Adjuncts to the Primary Survey
                    </Text>
                    <View style={styles.table1}>
                        <View style={styles.tableRow1}>

                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    NG/OG tube : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.ng_og_tube}</Text>

                                </Text>

                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Urethral cath : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.urethral_cath}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Portable chest X-ray : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.inv_p_cxr}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Arterial blood gas : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.abg}</Text>
                                </Text>
                            </View>
                        </View>


                    </View>

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            marginTop: 2,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>
                        Secondary Survey
                    </Text>

                    <View style={styles.table1}>
                        <View style={styles.tableRow1}>

                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Allergy : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.allergy}</Text>

                                </Text>

                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    ประวัติการดื่มสุรา : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.alcohol_history}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Medication : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.medication}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Last meal : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.last_meal}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_sub}>
                                <Text style={styles.textSubContrainer}>
                                    Past illness / Pregnancy : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.past_illness_pregnancy}</Text>
                                </Text>
                            </View>

                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_sub}>
                                <Text style={styles.textSubContrainer}>
                                    Events : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.events}</Text>
                                </Text>
                            </View>

                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textSubContrainer}>
                                    Head to toe examinations
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    Head - neck : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.head_neck}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'normal'
                                    }}>{input.head_neck_remark ? '- ' + input.head_neck_remark : ''}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    Heart - lungs : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.heart_lungs}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'normal'
                                    }}>{input.heart_lungs_remark ? '- ' + input.heart_lungs_remark : ''}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    Abdomen-pelvis : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.abdomen_pelvis}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'normal'
                                    }}>{input.abdomen_pelvis_remark ? '- ' + input.abdomen_pelvis_remark : ''}</Text>

                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    Extremities : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.extremities}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'normal'
                                    }}>{input.extremities_remark ? '- ' + input.extremities_remark : ''}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    Per-rectal exam : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.per_rectal_exam}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'normal'
                                    }}>{input.per_rectal_exam_remark ? '- ' + input.per_rectal_exam_remark : ''}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow1}>
                            <View style={styles.tableCol3_head}>
                                <Text style={styles.textSubContrainer}>
                                    Neurologic : <Text
                                    style={{fontSize: 12, fontWeight: 'normal'}}>{input.neurologic}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol3_remark}>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'normal'
                                    }}>{input.neurologic_remark ? '- ' + input.neurologic_remark : ''}</Text>
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            marginTop: 2,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    {
                        input.investigations?
                            <>
                                <Text style={styles.textHead}>
                                    Investigations
                                </Text>
                                <Text style={styles.textSubContrainer}>
                                    <Text style={{fontSize: 12, fontWeight: 'normal'}}>
                                        {input.investigations}
                                    </Text>
                                </Text>
                                <View
                                    style={{
                                        borderBottomColor: 'black',
                                        borderBottomWidth: 1,
                                        marginTop: 2,
                                        borderStyle: 'dotted',
                                        borderRadius: 1,
                                    }}
                                />
                            </>:null
                    }


                    <Text style={styles.textHead}>
                        Diagnosis
                    </Text>
                    <Text style={styles.textSubSecondary}>
                        Admission diagnosis : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.primary_diagnosis}</Text>
                    </Text>
                    <Text style={styles.textSubSecondary}>
                        Other problems : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.other_problems}</Text>
                    </Text>
                    <Text style={styles.textHead}>
                        Plan of managements
                    </Text>
                    <Text style={styles.textSubSecondary}>
                        <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.plan_of_managements}</Text>
                    </Text>

                    <View style={styles.table2}>
                        <View style={styles.tableRow2}>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;ผู้บาดเจ็บ {input.name} {input.surname}{"\n"}</Text>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;HN {input.hn}&nbsp;&nbsp;&nbsp;&nbsp;AN {input.an}{"\n"}</Text>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;เพศ {input.gender} &nbsp;&nbsp;&nbsp;&nbsp;อายุ
                                        : {input.age}{"\n"}</Text>

                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;ผู้บันทึก {input.record_name}{"\n"}</Text>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;{input.recode_code}{"\n"}</Text>
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;วันที่ {moment(input.record_datetime).format("DD-MM-YYYY HH:mm")} &nbsp;&nbsp;&nbsp;&nbsp;{"\n"}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    {"\n"}
                                    {"\n"}
                                    <Text style={{fontSize: 12, fontWeight: 'bold'}}> Sign :
                                        .....................................................................</Text>
                                </Text>
                            </View>

                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
}
export default Pdf;
